import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useToast } from '@chakra-ui/react';
import { addPlan } from 'api/auth.api';

export const useAddPlan = ({ onSuccess } = {}) => {
  const toast = useToast();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: addPlan,

    onSuccess: (res) => {
      toast({
        title: 'Plan created successfully',
        description: res?.data?.message || 'Plan added successfully',
        status: 'success',
        duration: 3000,
        isClosable: true,
        position: 'top-center',
      });

      queryClient.invalidateQueries(['plans-list']);

      onSuccess?.(res);
    },

    onError: (error) => {
      toast({
        title: 'Failed to create plan',
        description: error?.response?.data?.message || 'Something went wrong',
        status: 'error',
        duration: 4000,
        isClosable: true,
        position: 'top-center',
      });
    },
  });
};
